import * as Yup from 'yup';

// The form is built such that most of these invalid states should be
// unreachable, other than empty name and keywords;  but this is easy
// documentation of expectations.
export const keywordFormValidation = Yup.object().shape({
  name: Yup.string().required('You must give your keyword set a name.'),
  id: Yup.string(),
  keywords: Yup.array().min(
    1,
    'Enter at least one term or phrase to match against',
  ),
  speaker: Yup.string().oneOf(
    ['caller', 'operator', ''],
    'You must select at least one speaker to listen to for keywords.',
  ),
  tier_id: Yup.string().oneOf(
    ['tier-1', 'tier-2', 'tier-3'],
    'You must select a tier',
  ),
});
